/* =========================================================
   CUSTOM MEASUREMENTS (CMX) — FULL JS (REPLACE ENTIRE FILE)
   Fixes:
   - modal moved to body -> all modal queries must use modal scope
   - size chips clickable
   - figure values update live
   - Add to cart clickable + submits correct product form
   ========================================================= */

(function () {
  const root = document.querySelector('[data-cmx]');
  if (!root) return;

  const modal = root.querySelector('[data-cmx-modal]');
  if (!modal) return;

  // Hidden props LIVE IN ROOT (inside product form)
  const orderTypeProp = root.querySelector('[data-cmx-prop="orderType"]');
  const unitProp = root.querySelector('[data-cmx-prop="unit"]');
  const baseSizeProp = root.querySelector('[data-cmx-prop="baseSize"]');

  // Tabs LIVE IN ROOT
  const tabs = root.querySelectorAll('[data-cmx-mode]');

  /* Move modal to body (fixes theme stacking issues) */
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  // Everything INSIDE modal must be queried from modal
  const closeBtns = modal.querySelectorAll('[data-cmx-close]');
  const inputs = modal.querySelectorAll('[data-cmx-input]');
  const addBtn = modal.querySelector('[data-cmx-add]');
  const alertBox = modal.querySelector('[data-cmx-alert]');

  const qtyInput = modal.querySelector('[data-cmx-qty]');
  const minusBtn = modal.querySelector('[data-cmx-minus]');
  const plusBtn = modal.querySelector('[data-cmx-plus]');

  const sizeChips = modal.querySelectorAll('[data-cmx-size]');
  const unitBtns = modal.querySelectorAll('[data-cmx-unit]');

  // Figure values + units (multiple)
  const figUnits = modal.querySelectorAll('[data-cmx-figunit]');
  const figValues = (key) => modal.querySelector(`[data-cmx-fig="${key}"]`);

  function lockScroll(lock) {
    document.documentElement.classList.toggle('cmx-lock', lock);
    document.body.classList.toggle('cmx-lock', lock);
  }

  function openModal() {
    modal.hidden = false;
    lockScroll(true);
  }

  function closeModal() {
    modal.hidden = true;
    lockScroll(false);
  }

  /* Toggle mode */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      const mode = tab.dataset.cmxMode;

      if (mode === 'custom') {
        if (orderTypeProp) orderTypeProp.value = 'Custom';
        openModal();
        validate(); // refresh button state
      } else {
        if (orderTypeProp) orderTypeProp.value = 'Standard';
        closeModal();
      }
    });
  });

  /* Close buttons */
  closeBtns.forEach(btn => btn.addEventListener('click', closeModal));

  /* Quantity */
  minusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = Math.max(1, v - 1);
  });

  plusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = v + 1;
  });

  /* Size selection */
  sizeChips.forEach(chip => {
    chip.addEventListener('click', () => {
      sizeChips.forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      if (baseSizeProp) baseSizeProp.value = chip.dataset.cmxSize || '';
    });
  });

  /* Unit selection */
  unitBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      unitBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const u = (btn.dataset.cmxUnit || 'CM').toUpperCase();
      if (unitProp) unitProp.value = u;

      // Update all unit labels in fields
      modal.querySelectorAll('[data-cmx-ulabel]').forEach(l => {
        l.textContent = u.toLowerCase();
      });

      // Update all unit labels on figure
      figUnits.forEach(el => {
        el.textContent = u.toLowerCase();
      });
    });
  });

  /* Validation + figure + hidden props update */
  function validate() {
  // Define ranges in CM (single source of truth)
  const rangesCM = {
  bust:     { min: 50,  max: 150 },
  waist:    { min: 50,  max: 150 },
  hips:     { min: 50,  max: 150 },
  shoulder: { min: 20,  max: 50  },
  sleeve:   { min: 50,  max: 70  },
  stf:      { min: 120, max: 200 }
};

  const unit = (unitProp?.value || "CM").toUpperCase();
  const toIn = (cm) => +(cm / 2.54).toFixed(1);

  // Get range for current unit
  function getRange(key) {
    const r = rangesCM[key];
    if (!r) return null;
    if (unit === "IN") return { min: toIn(r.min), max: toIn(r.max) };
    return r; // CM
  }

  let valid = true;

  inputs.forEach(input => {
    const key = input.dataset.cmxInput;
    const val = parseFloat(input.value);

    // Update figure number
    const fig = figValues(key);
    if (fig) fig.textContent = isNaN(val) ? '–' : val;

    // Hidden prop
    const prop = root.querySelector(`[data-cmx-prop="${key}"]`);
    if (prop) prop.value = isNaN(val) ? '' : String(val);

    // Range + required validation
    const range = getRange(key);

    // Update "Guide: min–max"
    const guideEl = modal.querySelector(`[data-cmx-guide="${key}"]`);
    if (guideEl && range) guideEl.textContent = `${range.min}–${range.max} ${unit.toLowerCase()}`;

    // Error element
    const errEl = modal.querySelector(`[data-cmx-err="${key}"]`);

    // Default state
    input.classList.remove("cmx-invalid");
    if (errEl) errEl.hidden = true;

    // Required check
    if (isNaN(val) || val <= 0) {
      valid = false;
      return;
    }

    // Range check
    if (range && (val < range.min || val > range.max)) {
      valid = false;
      input.classList.add("cmx-invalid");
      if (errEl) {
        errEl.textContent = `Allowed range: ${range.min}–${range.max} ${unit.toLowerCase()}`;
        errEl.hidden = false;
      }
    }
  });

  if (addBtn) {
    addBtn.disabled = !valid;
    addBtn.setAttribute('aria-disabled', String(!valid));
  }
  if (alertBox) alertBox.hidden = valid;
}


  inputs.forEach(i => i.addEventListener('input', validate));

  /* Add to cart */
  addBtn?.addEventListener('click', () => {
    // Submit the REAL product form (root is still inside it)
    const form = root.closest('form');
    if (!form) return;

    // Sync quantity to Shopify main quantity input
    const mainQty = form.querySelector('input[name="quantity"]');
    if (mainQty && qtyInput) mainQty.value = qtyInput.value || '1';

    form.submit();
  });

  // Initialize defaults: base size from active chip
  const activeSize = modal.querySelector('[data-cmx-size].is-active');
  if (activeSize && baseSizeProp) baseSizeProp.value = activeSize.dataset.cmxSize || 'XS';

  // Initialize units on figure (default CM)
  figUnits.forEach(el => (el.textContent = 'cm'));

  // Initial validate state
  validate();

})();
